export const REACT_APP_GA_ACCOUNT = 'UA-106512451-1';
export const REACT_APP_DEBUG_GA = false;
